/*
 * @Author: Dom
 * @Date: 2022-05-13 09:27:30
 * @LastEditTime: 2022-06-06 11:38:19
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\main.ts
 */
import { createApp } from 'vue';

// 全局样式
import '@/assets/css/global.less';
import 'dayjs/locale/zh-cn';

// 引入 Antd
import Antd from 'ant-design-vue';

// 导入 svg
import { importAllSvg } from "@/components/IconSvg/index";
importAllSvg();

import App from '@/App.vue';
import router from '@/config/routes';
import store from '@/config/store';
import i18n from '@/config/i18n';

import customFilter from '@/filter'

const app = createApp(App)
app.use(store);
app.use(router)
app.use(Antd);
app.use(i18n);
app.use(customFilter)

app.mount('#app');
